import jumpContainer from './jumpContainer';

const NAMESPACE = '-rc-slider';
const CONTAINER = [...document.querySelectorAll(`.${NAMESPACE}`)];
const SELECTED_CLASS = `${NAMESPACE}__item--active`;

if (CONTAINER.length) {
    setTimeout(init, 0);
}

function init() {
    if (window.Flickity) {
        setTimeout(run, 0);
    } else {
        setTimeout(init, 50);
    }
}

function run() {
    CONTAINER.forEach(element => {
        const SLIDER = element.querySelector('.slider');
        const CONTROLLER = element.querySelector(`.${NAMESPACE}__controller`);
        const ITEMS = [...element.querySelectorAll(`.${NAMESPACE}__item`)];
        const SLIDER_INSTANCE = window.Flickity.data(SLIDER);
        const PROGRESS_BAR = element.querySelector(`.${NAMESPACE}__progress`);
        const MIN_WIDTH = parseInt(CONTROLLER.firstElementChild.style.minWidth);
        const CONTROLLER_PADDING = (() => {
            let style = getComputedStyle(CONTROLLER);
            return parseInt(style.paddingLeft) + parseInt(style.paddingRight);
        })();
        let scrollAmount = 0;

        SLIDER_INSTANCE.on('select', () => {
            const SELECTED = ITEMS.filter(el => el.firstElementChild.dataset.index == SLIDER_INSTANCE.selectedIndex)[0];
            SELECTED.classList.add(SELECTED_CLASS);

            // scroll into view
            const CONTROLLER_WIDTH = CONTROLLER.offsetWidth - CONTROLLER_PADDING;

            if (CONTROLLER_WIDTH < MIN_WIDTH) {
                const middle = CONTROLLER_WIDTH / 2;
                const offsetLeftSelected = SELECTED.offsetLeft;
                const maxScroll = CONTROLLER.firstElementChild.offsetWidth - CONTROLLER_WIDTH;

                // negative == left, positive == right
                const distanceToTheMiddleAbsolute = (middle - offsetLeftSelected - SELECTED.offsetWidth / 2) * -1;
                let newScrollAmount = Math.min(Math.max(0, distanceToTheMiddleAbsolute), maxScroll);

                // Only scroll for over 10 pixels
                if (Math.abs(newScrollAmount - scrollAmount) > 10) {
                    scrollAmount = newScrollAmount;
                    jumpContainer(CONTROLLER, scrollAmount);
                }
            }

            // Deselect prevoius items
            ITEMS.forEach(item => {
                if (item != SELECTED) {
                    item.classList.remove(SELECTED_CLASS);
                }
            });
        });

        if (PROGRESS_BAR) {
            SLIDER_INSTANCE.on('scroll', progress => {
                // Animate width of red progress bar
                progress = Math.max(0, Math.min(1, progress));
                PROGRESS_BAR.style.transform = `scaleX(${progress})`;
            });
        }

        CONTROLLER.addEventListener('click', event => {
            const TARGET = event.target;
            if (TARGET.classList.contains(`${NAMESPACE}__button`)) {
                SLIDER_INSTANCE.select(parseInt(TARGET.dataset.index));
            }
        });
    });
}
